export const loginForm = {
  LOGIN_FORM_CREATE_ACCOUNT_SUBMITTED: 'loginFormCreateAccount.submitted'
}
